module.exports = __webpack_public_path__ + "img/mt.f6e3733c.svg";